// extracted by mini-css-extract-plugin
export var active = "_jm-e";
export var blink = "_jm-f";
export var dropDownSelector = "_jm-5";
export var dropDownWrapper = "_jm-4";
export var fakeCursor = "_jm-d";
export var fontSizeButton = "_jm-7";
export var formQuillEditor = "_jm-0";
export var pressed = "_jm-g";
export var qlBlank = "_jm-1";
export var textFormattingToolbar = "_jm-2";
export var textFormattingToolbarClosed = "_jm-3";
export var textFormattingToolbarInline = "_jm-6";
export var textToolbarOption = "_jm-8";
export var toolbarCell = "_jm-a";
export var toolbarCellCollapsed = "_jm-b";
export var toolbarOptionHitArea = "_jm-c";
export var toolbarOverflow = "_jm-9";